import { TextareaWithLabel } from 'shared/ui'
import { useTextareaAutoResize } from 'shared/hooks'
import { type ITextareaWithLabelProps } from 'shared/ui/Textarea/TextareaWithLabel/TextareaWithLabel.tsx'

export const AgentVoiceResponse = ({
  value,
  onChange,
}: {
  value: ITextareaWithLabelProps['value']
  onChange: ITextareaWithLabelProps['onChange']
}) => {
  const agentVoiceResponseTextareaRef = useTextareaAutoResize(value, 84, 184)

  return (
    <TextareaWithLabel
      ref={agentVoiceResponseTextareaRef}
      value={value}
      rows={3}
      name={'agentVoiceResponse'}
      onChange={onChange}
      placeholder={
        "e.g. I'll send you a quick text message with a link to our pricing page so you can review the plans."
      }
      labelProps={{
        marginBottom: 0,
        questionTooltipProps: {
          label: 'What the agent says before sending the SMS',
          placement: 'top',
        },
        label: {
          text: 'Agent voice response',
          secondaryText: '(optional)',
        },
      }}
    />
  )
}
